<template>
  <thead class="item sort">
    <th v-for="item in 5" :key="item">
      <v-skeleton-loader type="text" />
    </th>
    <th></th>
  </thead>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
thead {
  th {
    border-bottom: 1px solid map-get($gray, lighten2);

    height: 52px;
    &:first-child {
      .v-skeleton-loader {
        margin-left: 8px;
      }
    }

    width: 210px;
    &:nth-child(6) {
      width: 280px;
    }

    padding: 6px 16px;
    .v-skeleton-loader {
      max-width: 62px;
    }
  }
}
</style>